import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SystemActionIndexComponent } from './crud-index/crud-index.component';
import { SystemActionCESComponent } from './crud-ces/crud-ces.component';

const routes: Routes = [
  {
    path: '',
    component: SystemActionIndexComponent,
  },
  {
    path: 'create',
    component: SystemActionCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: SystemActionCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: SystemActionCESComponent,
    data: [{ action: 'edit' }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SystemActionsRoutingModule {}
